import {StyleBuilder, TableConfig} from 'ngx-aur-mat-table';

import {DriverHistory} from '@common-module/modelinterfaces/driver-history.model';
import {DriverAction} from '@common-module/modelinterfaces/enums/driver-action';
import {ServerTablePaginationConfigState} from '@common-module/table-config/server-table-pagination';
import {TableConfigBuilder} from '@common-module/table-config/table-config.builder';

export function createDriverHistoryTableConfig(
  translate: (key: string) => string,
  timeZone: string,
  pagination: ServerTablePaginationConfigState,
): TableConfig<DriverHistory> {
  return {
    trackBy: history => history.id,
    paginationCfg: TableConfigBuilder.pagination.server(
      pagination.pageSize,
      pagination.pageSizeOptions,
      'sticky',
    ),
    columnsCfg: [
      {
        key: 'unit-type',
        name: '',
        valueConverter: () => '',
        valueView: {
          icon: {
            name: () => 'directions_car',
          },
        },
        align: 'center',
        size: {
          fit: true,
        },
      },
      {
        ...TableConfigBuilder.column.value(
          'unit',
          translate('term.unit'),
          // История может приходить без связанного объекта; сама запись остаётся значимой.
          history => history.unit?.name ?? '—',
        ),
        sort: TableConfigBuilder.column.sort.enabled(),
      },
      {
        ...TableConfigBuilder.column.timestamp(
          'time',
          translate('term.time'),
          history => history.time,
          'dd.MM.yyyy HH:mm',
          timeZone,
        ),
        sort: TableConfigBuilder.column.sort.enabled(),
      },
      {
        key: 'action',
        name: translate('term.action'),
        valueConverter: history => translate(
          history.action === DriverAction.TAKE
            ? 'message.info.assigned'
            : 'message.info.unassigned',
        ),
        valueView: {
          icon: {
            name: row => row.rowSrc.action === DriverAction.TAKE
              ? 'insert_link'
              : 'link_off',
          },
        },
      },
    ],
    stickyCfg: TableConfigBuilder.sticky.header(),
    bodyRowCfg: {
      hoverCfg: TableConfigBuilder.row.hover.disabled(),
      styleCfg: {
        class: () => 'not-hover',
        style: row => row.rowSrc.active
          ? StyleBuilder.Row.builder().color('var(--color-primary)')
          : StyleBuilder.Row.builder(),
      },
    },
  };
}
